import Commons from '../../Services/Common/Common';
import dayjs from 'dayjs';

/**
 * Home 스키마
 * - fields: 폼/그리드에서 공통으로 쓰는 필드 정의
 * - mapper: 저장/삭제 API payload 생성 규칙 (현재는 조회만 사용)
 */
export const Home_Schema = {
  mapper: {
    // 공지사항 조회
    search1: {
      CoCd: (_, context) =>
        context.userInfo?.authCd === 'ADMIN'
          ? Commons.EncryptAES(context.search?.coCd || '') || ''
          : Commons.EncryptAES(
              context.search?.coCd ?? context.userInfo?.coCd ?? ''
            ) || '',
      CustCd: (_, context) =>
        Commons.EncryptAES(
          context.search?.custCd ?? context.userInfo?.custCd ?? ''
        ) || '',
      AuthCd: (_, context) =>
        Commons.EncryptAES(context.userInfo?.authCd || '') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },
    // 알람 상세 조회
    search2: {
      UserId: (_, context) => context.userInfo?.userid || '',
    },
    // 안전뉴스 조회 - 파라미터 없음
    // search3는 파라미터가 없으므로 mapper 불필요
    // 내 캘린더 조회
    search4: {
      UserId: (_, context) => context.userInfo?.userid || '',
    },
    // 달력 일정 조회 (월간 달력용)
    // 홈 통합 조회 (서버 GetHomeData) — RiskWorkerOpinionMenuActive 등
    getHomeData: {
      UserId: (_, context) =>
        Commons.EncryptAES(context.userInfo?.userid ?? '') || '',
      AuthCd: (_, context) =>
        Commons.EncryptAES(context.userInfo?.authCd ?? '') || '',
      CoCd: (_, context) =>
        context.userInfo?.authCd === 'ADMIN'
          ? Commons.EncryptAES('') || ''
          : Commons.EncryptAES(context.userInfo?.coCd ?? '') || '',
      CustCd: (_, context) =>
        Commons.EncryptAES(
          context.search?.custCd || context.userInfo?.custCd || ''
        ) || '',
      DepCd: (_, context) =>
        Commons.EncryptAES(context.search?.depCd ?? '') || '',
      TbmYn: (_, context) => Commons.EncryptAES(context.tbmYn ?? 'N') || '',
    },
    search5: {
      UserId: (_, context) => context.userInfo?.userid || '',
      StartDt: (_, context) => {
        const currentDate = dayjs(context.currentDate || dayjs());
        const startDate = currentDate
          .startOf('month')
          .startOf('week')
          .startOf('day');
        return (
          Commons.EncryptAES(startDate.format('YYYY-MM-DD HH:mm:ss')) || ''
        );
      },
      EndDt: (_, context) => {
        const currentDate = dayjs(context.currentDate || dayjs());
        const endDate = currentDate
          .endOf('month')
          .endOf('week')
          .startOf('day')
          .add(1, 'day')
          .subtract(1, 'second');
        return Commons.EncryptAES(endDate.format('YYYY-MM-DD HH:mm:ss')) || '';
      },
    },
    search6: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
      UserId: (_, context) => context.userInfo?.userid,
      SearchText: (_, context) => Commons.EncryptAES(''),
    },
    save1: {
      WorkId: (row) => (row.workId ? Number(row.workId) : 0),
      CustCd: (_, context) => Commons.EncryptAES(context.search.custCd), // ← 암호화 유지
      Title: (row) => String(row.title || ''), // ← 암호화 제거
      Contents: (row) => String(row.contents || ''), // ← 암호화 제거
      PriorityBit: (row) => row.priorityBit ?? 2, // ← 암호화 제거
      StatusCd: (row) => String(row.statusCd || '10'), // ← 암호화 제거
      StartDt: (row) => row.startDt || null, // ← 암호화 제거
      DueDt: (row) => row.dueDt || null, // ← 암호화 제거
      ComplDt: (row) => row.complDt || null, // ← 암호화 제거
      UserId: (_, context) => context.userInfo?.userid,
    },

    // 업무 목록 상태 변경
    save2: {
      WorkId: (row) => (row.workId ? Number(row.workId) : 0), // 암호화 제거
      StatusCd: (row) => String(row.statusCd || '10'), // 암호화 제거
      UserId: (_, context) => context.userInfo?.userid,
    },

    // 업무 목록 우선 순위 변경
    save3: {
      WorkId: (row) => (row.workId ? Number(row.workId) : 0), // 암호화 제거
      PriorityBit: (row) => row.priorityBit ?? 2, // 암호화 제거
      PinYn: (row) => row.pinYn || 'N',
      UserId: (_, context) => context.userInfo?.userid,
    },

    // 알람 확인 처리
    save4: {
      Gubun: (row) => row.gubun,
      AlarmCd: (row) => row.alarmCd || '',
      UserId: (_, context) => context.userInfo?.userid,
    },

    // 업무 삭제
    delete1: {
      WorkId: (row) => (row.workId ? Number(row.workId) : 0),
      UserId: (_, context) => context.userInfo?.userid,
    },
  },
};
